import { render, staticRenderFns } from "../templates/normal_fcont_2.html?vue&type=template&id=d1f4c92e&"
import script from "./normal_fcont_2.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports